import { useLayoutEffect } from 'react';

const getColCount = (width: number) => Math.min(6, Math.max(1, Math.ceil((width - 50) / 250)));

export default function useColCountObserver(
    scrollEl: HTMLDivElement | null,
    onChange: (count: number) => void
) {
    useLayoutEffect(() => {
        if (!scrollEl || typeof ResizeObserver === 'undefined') return;

        const width = scrollEl.getBoundingClientRect().width;
        onChange(getColCount(width));

        const ro = new ResizeObserver(([entry]) => {
            const width = Array.isArray(entry.borderBoxSize)
                ? entry.borderBoxSize[0].inlineSize
                : scrollEl.getBoundingClientRect().width;
            onChange(getColCount(width));
        });

        ro.observe(scrollEl);
        return () => ro.disconnect();
    }, [scrollEl, onChange]);
}
